/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ContactWithRelations } from '../models/contact-with-relations';
import { inventoryCreateContact } from '../fn/inventory-contacts-controller/inventory-create-contact';
import { InventoryCreateContact$Params } from '../fn/inventory-contacts-controller/inventory-create-contact';
import { inventoryDeleteContact } from '../fn/inventory-contacts-controller/inventory-delete-contact';
import { InventoryDeleteContact$Params } from '../fn/inventory-contacts-controller/inventory-delete-contact';
import { inventoryGetContact } from '../fn/inventory-contacts-controller/inventory-get-contact';
import { InventoryGetContact$Params } from '../fn/inventory-contacts-controller/inventory-get-contact';
import { inventoryGetContacts } from '../fn/inventory-contacts-controller/inventory-get-contacts';
import { InventoryGetContacts$Params } from '../fn/inventory-contacts-controller/inventory-get-contacts';
import { inventoryUpdateContact } from '../fn/inventory-contacts-controller/inventory-update-contact';
import { InventoryUpdateContact$Params } from '../fn/inventory-contacts-controller/inventory-update-contact';
import { moveContactToGlobal } from '../fn/inventory-contacts-controller/move-contact-to-global';
import { MoveContactToGlobal$Params } from '../fn/inventory-contacts-controller/move-contact-to-global';

@Injectable({ providedIn: 'root' })
export class InventoryContactsControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `contactsControllerMoveContactToGlobal()` */
  static readonly ContactsControllerMoveContactToGlobalPath = '/inventory/contacts/move-to-global';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `moveContactToGlobal()` instead.
   *
   * This method doesn't expect any request body.
   */
  moveContactToGlobal$Response(params: MoveContactToGlobal$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return moveContactToGlobal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `moveContactToGlobal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  moveContactToGlobal(params: MoveContactToGlobal$Params, context?: HttpContext): Observable<any> {
    return this.moveContactToGlobal$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `contactsControllerInventoryGetContact()` */
  static readonly ContactsControllerInventoryGetContactPath = '/inventory/contacts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inventoryGetContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryGetContact$Response(params: InventoryGetContact$Params, context?: HttpContext): Observable<StrictHttpResponse<ContactWithRelations>> {
    return inventoryGetContact(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inventoryGetContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryGetContact(params: InventoryGetContact$Params, context?: HttpContext): Observable<ContactWithRelations> {
    return this.inventoryGetContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContactWithRelations>): ContactWithRelations => r.body)
    );
  }

  /** Path part for operation `contactsControllerInventoryGetContacts()` */
  static readonly ContactsControllerInventoryGetContactsPath = '/inventory/contacts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inventoryGetContacts()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryGetContacts$Response(params: InventoryGetContacts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContactWithRelations>>> {
    return inventoryGetContacts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inventoryGetContacts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryGetContacts(params: InventoryGetContacts$Params, context?: HttpContext): Observable<Array<ContactWithRelations>> {
    return this.inventoryGetContacts$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ContactWithRelations>>): Array<ContactWithRelations> => r.body)
    );
  }

  /** Path part for operation `contactsControllerInventoryCreateContact()` */
  static readonly ContactsControllerInventoryCreateContactPath = '/inventory/contacts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inventoryCreateContact()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inventoryCreateContact$Response(params: InventoryCreateContact$Params, context?: HttpContext): Observable<StrictHttpResponse<ContactWithRelations>> {
    return inventoryCreateContact(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inventoryCreateContact$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inventoryCreateContact(params: InventoryCreateContact$Params, context?: HttpContext): Observable<ContactWithRelations> {
    return this.inventoryCreateContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContactWithRelations>): ContactWithRelations => r.body)
    );
  }

  /** Path part for operation `contactsControllerInventoryDeleteContact()` */
  static readonly ContactsControllerInventoryDeleteContactPath = '/inventory/contacts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inventoryDeleteContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryDeleteContact$Response(params: InventoryDeleteContact$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return inventoryDeleteContact(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inventoryDeleteContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryDeleteContact(params: InventoryDeleteContact$Params, context?: HttpContext): Observable<any> {
    return this.inventoryDeleteContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `contactsControllerInventoryUpdateContact()` */
  static readonly ContactsControllerInventoryUpdateContactPath = '/inventory/contacts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inventoryUpdateContact()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inventoryUpdateContact$Response(params: InventoryUpdateContact$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return inventoryUpdateContact(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inventoryUpdateContact$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inventoryUpdateContact(params: InventoryUpdateContact$Params, context?: HttpContext): Observable<any> {
    return this.inventoryUpdateContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

}
